import { render, staticRenderFns } from "./MyApprovals.vue?vue&type=template&id=0e2c9e52&"
import script from "./MyApprovals.vue?vue&type=script&lang=js&"
export * from "./MyApprovals.vue?vue&type=script&lang=js&"
import style0 from "./MyApprovals.vue?vue&type=style&index=0&id=0e2c9e52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VChip,VDataTable,VIcon})
